module.exports = __webpack_public_path__ + "static/10.01.01.weekly-planner-3e77f5b0dd3fe3d80beda1aeb6afc4ed.png";